interface Props {
    name: string;
    label: string;
    value: string | number | null;
    onChange: (name: string, value: string) => void;
    required: boolean;
    maxLength?: number | null;
    readOnly?: boolean | null;
    hiddeLabel?: boolean;
    isDisabled?: boolean;
}

export default function TextField({
    name,
    label,
    value,
    required,
    onChange,
    maxLength = 50,
    readOnly,
    hiddeLabel = false,
    isDisabled,
}: Props) {
    const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        event.target.classList.add('touched');
    };

    return (
        <div className='mb-3'>
            {!hiddeLabel ? (
                <label htmlFor={name} key={`label-${name}`} className='form-label'>
                    {label}
                </label>
            ) : null}
            <input
                type='text'
                className='form-control'
                id={name}
                key={name}
                name={name}
                value={value ?? ''}
                required={required}
                onChange={(e) => onChange(name, e.target.value)}
                onFocus={onFocus}
                maxLength={maxLength ?? 50}
                readOnly={readOnly ?? false}
                placeholder={label}
                disabled={isDisabled}
            />
        </div>
    );
}
